import * as React from "react";
import {
    PlasmicHomepage,
    DefaultHomepageProps
} from "./plasmic/main/PlasmicHomepage";
import {useEffect, useState} from "react";
import ProjectCard from "./ProjectCard";
import {Project} from "../models/fauna/dbSchema";
import {deleteProject, getSharedProjects, getUserProjects, updateProject} from "../api/fetch-requests";
import {toast, ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

export interface HomepageProps extends DefaultHomepageProps {
    children?: never;
    user?: any

}

const toastTexts = {
    pending: {
        render() {
            return "Loading"
        }
    },
    success: {
        render() {
            return "Ready"
        },
        autoClose: 100
    },
    error: {
        render() {
            return "Error"
        },
        autoClose: 500
    }
}

function Homepage({user ,...props}: HomepageProps) {
    const [entries, setEntries] = useState<Project[]>([]);

    useEffect(() => {
        if (user) {
            toast.promise(getUserProjects().then((projects: Project[]) => {
                getSharedProjects().then((sharedProjects: Project[]) => {
                    setEntries([...projects, ...sharedProjects]);
                });
            }), toastTexts);
        } else {
            setEntries([]);
        }
    }, [user]);

    return <PlasmicHomepage
        {...props}
        projectContainer={{
            children: entries.reverse().map((entry) => (
                <ProjectCard
                    entry={entry}
                    onChange={(name) =>
                        updateProject(entry.id, {name}).then(() =>
                            setEntries(entries.map((e) =>
                                (e.id === entry.id ? {...entry, name} : e))
                            )
                        )
                    }
                    onDelete={() =>
                        deleteProject(entry.id, entry.status === 'demo').then(() =>
                            setEntries(entries.filter(
                                (e) => e.id !== entry.id)
                            )
                        )
                    }
                />
            ))
        }}
        toastify={{
            render: () => (<ToastContainer position="bottom-right"/>)
        }}
    />;
}

export default Homepage;

